import { Link } from 'react-router-dom'

import React from 'react'

export const Hero = () => {
  return (
    
    <div>
        
        <img className=" object-cover w-full h-[350px] md:h-full lg:h-full" src='Images/hero.png' alt=''/>
        
      </div>

    
  )

}
